import { getSentryClient } from '@atlassian/mpac-utils';
import React, { useContext, useEffect, useState } from 'react';
import { getCurrentNetworkStatus, getNetworkStatusBreadcrumb } from './utils';
const NetworkStatusContext = /*#__PURE__*/React.createContext(getCurrentNetworkStatus());
const {
  Provider: NetworkStatusContextProvider
} = NetworkStatusContext;
export const NetworkStatusTracker = props => {
  const {
    children
  } = props;
  const [networkStatus, setNetworkStatus] = useState(getCurrentNetworkStatus());
  useEffect(() => {
    const onNetworkStatusChange = () => {
      const status = getCurrentNetworkStatus();
      setNetworkStatus(status);
      if (status.type !== 'supported') return;
      const sentryClient = getSentryClient();
      if (sentryClient) {
        sentryClient.addBreadcrumb(getNetworkStatusBreadcrumb(status.online));
      }
    };
    if (typeof window.addEventListener === 'function') {
      window.addEventListener('online', onNetworkStatusChange);
      window.addEventListener('offline', onNetworkStatusChange);
    }
    return () => {
      if (typeof window.removeEventListener === 'function') {
        window.removeEventListener('online', onNetworkStatusChange);
        window.removeEventListener('offline', onNetworkStatusChange);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(NetworkStatusContextProvider, {
    value: networkStatus
  }, children);
};
export const useNetworkStatus = () => useContext(NetworkStatusContext);